import { FundingPolicyTypeDef } from '@shared';
import { Badge } from './ui/badge';

export function PolicyTypeSelectDisplay({
  policyType,
}: {
  policyType: FundingPolicyTypeDef;
}) {
  return (
    <span className="flex flex-row items-center gap-2 font-medium text-gray-800">
      {`${policyType.label}`}
      <Badge
        className={`${policyType.carrier ? 'border-blue-200 bg-blue-50 text-blue-500' : 'border-gray-200 bg-gray-100 text-gray-600'} text-xs font-normal`}
        variant="outline"
      >
        {policyType.carrier ? `${policyType.carrier} ` : 'Generic'}
      </Badge>
      {policyType.isJoint && (
        <Badge
          className="border-primary-200 bg-primary-100 text-xs font-normal text-primary"
          variant="outline"
        >
          Joint
        </Badge>
      )}
    </span>
  );
}

export function PolicyTypeComboboxOption({
  policyType,
}: {
  policyType: FundingPolicyTypeDef;
}) {
  return (
    <div className="flex flex-col gap-1 p-2">
      <PolicyTypeSelectDisplay policyType={policyType} />
      <span className="text-sm text-gray-600">{policyType.description}</span>
    </div>
  );
}
